export default __webpack_public_path__ + "static/Georgia-af2a95bc538f7e044915aadff1900688.ttf";